<template>
  <CustomModal
    class="images-info-modal"
    :is-modal-open="isOpen"
    @toggleModal="() => emit('closeModal')"
    @onClickAway="() => emit('closeModal')"
    :overlay="'dark'"
    :with-header="true"
    :with-footer="true"
    :custom-classes="'tw:w-[100vw] tw:md:max-w-[500px] tw:md:w-[500px] tw:md:rounded-md tw:rounded-none'"
  >
    <template #modalHeader>
      <p class="tw:text-xl tw:text-gray-700">{{ $t('image_order_header') }}</p>
    </template>

    <div>
      <p class="tw:mb-5">{{ $t('image_order_info') }}</p>
      <p class="tw:text-sm tw:mb-3 tw:text-gray-600">{{ $t('image_order_footnote') }}</p>
      <CheckPropertyLink :isBlue="true" />
    </div>

    <template #modalFooter>
      <div class="tw:flex tw:justify-end tw:w-full">
        <MainButton @click="emit('closeModal')">{{ $t('image_order_cta') }}</MainButton>
      </div>
    </template>
  </CustomModal>
</template>
<script setup>
import MainButton from '@/components/base/buttons/MainButton.vue'
import CustomModal from '@/components/base/CustomModal.vue'
import CheckPropertyLink from '@/components/dashboard/CheckPropertyLink.vue'

const emit = defineEmits(['closeModal'])
defineProps({
  isOpen: Boolean,
})
</script>
